<template>
  <div class="mb-3">
    <div class="row">
      <b-col cols="10">
        <h3>{{ resource.title }}</h3>
      </b-col>
      <b-col cols="2"> {{ resource.avg_rating }}/5 </b-col>
      <!-- Title, rating -->
    </div>
    <div class="row">
      <b-col cols="4">
        {{ itemTypeTitle(resource.item_type) }}
      </b-col>
      <b-col cols="8">
        <router-link :to="`/user/${resource.owner.uuid}`">
          <img
            class="rounded-circle img-profile mr-2"
            :src="resource.owner.avatar"
            :alt="`${resource.owner.first_name} ${resource.owner.last_name}`"
          />
          {{ resource.owner.first_name }} {{ resource.owner.last_name }}
        </router-link>
      </b-col>
      <!-- Resource Type, Creator -->
    </div>
    <div class="row">
      <!-- Skills text -->
      <b-col cols="12">
        {{ skillsText(resource) }}
      </b-col>
    </div>
    <div class="row mb-2">
      <b-col cols="12">
        <!-- Description -->
        {{ resource.description }}
      </b-col>
    </div>
    <div class="row">
        <b-col cols="3">
            <div class="d-flex justify-flex-end">
                <!-- Action button here, will need dynamic title -->
                <b-btn
                  variant="secondary"
                  size="sm"
                  v-on:click="$emit('action-button-tapped', resource)"
                >
                  {{ actionTitle }}
                </b-btn>
            </div>
        </b-col>
    </div>
  </div>
</template>

<script>
/*
 * Educational Item Summary (better class name)
 * Simple component that shows title, description, resource type, rating?, skills, creator?
 * Need optional action inputs, or set choices (Remove from meeting, View Details)
 * Takes an input of an educational item, required
 */
export default {
  name: 'EducationalItemSummary',
  props: {
    resource: Object,
    actionTitle: String
  },
  methods: {
    /**
     * Returns a more human readable title for EducationalResourceItemTypes
     */
    itemTypeTitle(itemType) {
      switch (itemType) {
        case 'pdf':
        case 'url':
        case 'mp4':
          return itemType.toUpperCase()
        case 'ppt':
          return 'Power Point'
        case 'xls':
          return 'Excel'
        case 'youtube':
          return 'YouTube'
        case 'gdrive':
          return 'Google Drive'
        default:
          return ''
      }
    },
    /**
     * Returns a combination of the titles of all associated skills into one string
     */
    skillsText(resource) {
      if (!resource.skills || resource.skills.length == 0) {
        return ''
      }

      return resource.skills.map((s) => s.title.split(' ')[0]).join(', ')
    },
    /**
     * Returns the text to be displayed in the action button
     */
    actionText() {
      return this.forSelection ? "Select" : "Remove"
    },
  },
}
</script>

<style scoped>
.img-profile {
  width: 24px;
  height: 24px;
}
</style>
